import { render, staticRenderFns } from "./floatingBanner.vue?vue&type=template&id=2cb5774e&scoped=true"
import script from "./floatingBanner.vue?vue&type=script&lang=js"
export * from "./floatingBanner.vue?vue&type=script&lang=js"
import style0 from "./floatingBanner.vue?vue&type=style&index=0&id=2cb5774e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb5774e",
  null
  
)

export default component.exports